/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Tlm_3Inputs */

const en_svc_browser_extensions_tlm_3 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`distribution`)
};

const ar_svc_browser_extensions_tlm_3 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التوزيع`)
};

const bn_svc_browser_extensions_tlm_3 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`distribution`)
};

const de_svc_browser_extensions_tlm_3 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verteilung`)
};

const es_svc_browser_extensions_tlm_3 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`distribución`)
};

const fr_svc_browser_extensions_tlm_3 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribution`)
};

const pt_svc_browser_extensions_tlm_3 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribuição`)
};

const zh_svc_browser_extensions_tlm_3 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分布`)
};

const tr_svc_browser_extensions_tlm_3 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dağıtım`)
};

const ru_svc_browser_extensions_tlm_3 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`распространение`)
};

const pl_svc_browser_extensions_tlm_3 = /** @type {(inputs: Svc_Browser_Extensions_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dystrybucja`)
};

/**
* | output |
* | --- |
* | "distribution" |
*
* @param {Svc_Browser_Extensions_Tlm_3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_tlm_3 = /** @type {((inputs?: Svc_Browser_Extensions_Tlm_3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Tlm_3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_tlm_3(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_tlm_3(inputs)
	if (locale === "de") return de_svc_browser_extensions_tlm_3(inputs)
	if (locale === "es") return es_svc_browser_extensions_tlm_3(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_tlm_3(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_tlm_3(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_tlm_3(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_tlm_3(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_tlm_3(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_tlm_3(inputs)
	return en_svc_browser_extensions_tlm_3(inputs)
});
export { svc_browser_extensions_tlm_3 as "svc_browser-extensions_tlm_3" }